export default function checkIfSubtestComplete(userAssessment, subtestId) {
  return !!(
    userAssessment.destructuredSubtests[subtestId] && 
    userAssessment.destructuredSubtests[subtestId].complete
  )
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/checkIfSubtestComplete.js